import {
  List,
  Card,
  Row,
  Col,
  DatePicker,
  Button,
  Tooltip,
  message,
} from "antd";
import { useEffect, useState } from "react";

import "./AddVisit.css";
import visitService from "../../services/visitService";
import RescoStorage from "../../utils/rescoStorage";
import ShipImage from "../../img/default-ship.jpg";

import { ShipInfo, ShipPlacesInfo } from "../../types/visitTypes";

const { Meta } = Card;
const { RangePicker } = DatePicker;

const ShipAndDateSelection = (props: {
  toggleFunction: any;
  shipId: number | null;
  startdate: Date | null;
  enddate: Date | null;
  ships: ShipInfo[];
  portName: string | null;
  eventId: number | null;
  shipsPlaces: ShipPlacesInfo[];
}) => {
  const [startdate, setStartDate] = useState<Date | null>(null);
  const [enddate, setEndDate] = useState<Date | null>(null);
  const [shipId, setShipId] = useState<number | null>(null);
  const [portName, setPortName] = useState<string | null>(null);
  const [eventId, setEventId] = useState<number | null>(null);
  const [ships, setShips] = useState<ShipInfo[]>([]);
  const [shipsPlaces, setShipsPlaces] = useState<ShipPlacesInfo[]>([]);
  const [isValid, setIsValid] = useState<boolean>(true);

  const errorInfo = (info: string) => {
    message.error(info);
  };

  useEffect(() => {
    if (props.shipId != null) {
      setShipId(props.shipId);
      setShips(props.ships);
      setShipsPlaces(props.shipsPlaces);
      setStartDate(props.startdate);
      setEndDate(props.enddate);
      setPortName(props.portName);
      setEventId(props.eventId);
    } else {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    const shipsStorageInfo = RescoStorage.getShip();
    if (!shipsStorageInfo) {
      const shipsInfo = await visitService.GetShipsList();
      if (shipsInfo == null) {
        errorInfo("Fetching ship Failed");
      }
      if (shipsInfo && shipsInfo.data && shipsInfo.data.length > 0) {
        const data = shipsInfo.data.map(
          (ship) =>
            ({
              Id: ship.Id,
              Code: ship.Code,
              Name: ship.Name,
              ImageBase64: ship.ImageBase64,
              Description: ship.Description,
            } as ShipInfo)
        );
        RescoStorage.setShip(data);
        setShips(data);
      }
    } else {
      setShips(shipsStorageInfo);
    }
  };

  function onDateChange(startdate: Date | null, enddate: Date | null) {
    if (startdate !== null && enddate !== null) {
      setIsValid(true);
      setStartDate(startdate);
      setEndDate(enddate);
      var shipPlace = shipsPlaces.find(
        (shipsPlace) =>
          shipsPlace.ShipId === shipId &&
          shipsPlace.Date.getDate() === startdate?.getDate() &&
          shipsPlace.Date.getMonth() === startdate?.getMonth() &&
          shipsPlace.Date.getFullYear() === startdate?.getFullYear()
      );
      if (shipPlace != null) {
        setPortName(shipPlace.PlaceName);
        setEventId(shipPlace.EventId);
      }
    }
  }

  const fetchShipsPlacesData = async (shipId: number) => {
    const shipsPlacesInfo = await visitService.GetShipsPlacesList(shipId);

    if (shipsPlacesInfo == null) {
      errorInfo("Fetching Failed");
    }
    if (
      shipsPlacesInfo &&
      shipsPlacesInfo.data &&
      shipsPlacesInfo.data.length > 0
    ) {
      const data = shipsPlacesInfo.data.map(
        (shipPlaces) =>
          ({
            ShipId: shipPlaces.ShipId,
            ShipName: shipPlaces.ShipName,
            PlaceId: shipPlaces.PlaceId,
            PlaceCode: shipPlaces.PlaceCode,
            PlaceName: shipPlaces.PlaceName,
            Type: shipPlaces.Type,
            Date: new Date(shipPlaces.Date),
            EventId: shipPlaces.EventId,
          } as ShipPlacesInfo)
      );
      setShipsPlaces(data);
    } else {
      setShipsPlaces([]);
    }
  };

  function onShipChange(facilityId: number | null) {
    if (facilityId !== null && shipId !== facilityId) {
      setIsValid(true);
      setStartDate(null);
      setEndDate(null);
      setPortName(null);
      setEventId(null);
      setShipId(facilityId);
      fetchShipsPlacesData(facilityId);
    }
  }

  function disabledDate(current: any) {
    var result = false;
    shipsPlaces.forEach((element) => {
      if (
        current !== null &&
        current.year() === element.Date.getFullYear() &&
        current.month() === element.Date.getMonth() &&
        current.date() === element.Date.getDate()
      ) {
        result = true;
      }
    });
    return !result;
  }

  function DataPicker() {
    return (
      <RangePicker
        className={isValid ? "" : "add-visit-validate"}
        allowClear={false}
        size="large"
        disabled={shipId == null}
        disabledDate={disabledDate}
        dateRender={(current) => {
          const style = {
            background: "ant-picker-cell-inner",
          };

          shipsPlaces.forEach((element) => {
            if (
              current.year() === element.Date.getFullYear() &&
              current.month() === element.Date.getMonth() &&
              current.date() === element.Date.getDate()
            ) {
              if(element.Type === "AA" || element.Type === "DD")
                style.background = "add-visit-picker-highlighted ant-picker-cell-inner";
              else
                style.background = "add-visit-picker ant-picker-cell-inner";
            }
          });
          return <div className={style.background}>{current.date()}</div>;
        }}
        onChange={(e, s) =>
          onDateChange(e?.[0]?.toDate() ?? null, e?.[1]?.toDate() ?? null)
        }
      />
    );
  }

  function ShowDataPicker(shipId: number | null) {
    if (shipId === null) {
      return (
        <Tooltip title="please select a ship" placement="bottom">
          {DataPicker()}
        </Tooltip>
      );
    } else {
      return <div>{DataPicker()}</div>;
    }
  }

  const setSelectionCompleted = () => {
    if (shipId === null || startdate === null || enddate === null) {
      setIsValid(false);
    } else {
      props.toggleFunction(
        shipId,
        startdate,
        enddate,
        ships,
        portName,
        eventId,
        shipsPlaces
      );
    }
  };

  return (
    <>
      <div className="add-visit-step-1">
        <div className="add-visit-ships">
          <Row>
            <Col span={12} offset={6}>
              <span>
                <h1>Select ship</h1>
              </span>
              <List
                grid={{
                  gutter: 16,
                  xs: 1,
                  sm: 1,
                  md: 2,
                  lg: 2,
                  xl: 3,
                  xxl: 3,
                }}
                dataSource={ships}
                renderItem={(item) => (
                  <List.Item>
                    <Card
                      className={
                        item.Id === shipId
                          ? "add-visit-ship-selected"
                          : !isValid && shipId === null
                          ? "add-visit-validate"
                          : ""
                      }
                      hoverable
                      onClick={() => onShipChange(item.Id)}
                      cover={
                        <img
                          alt={item.Name}
                          src={`data:image/jpeg;base64,${item.ImageBase64}`}
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = ShipImage;
                          }}
                        />
                      }
                    >
                      <Meta title={item.Name} description={item.Description} />
                    </Card>
                  </List.Item>
                )}
              />
              <div
                className={
                  !isValid && shipId === null && ships.length > 0
                    ? "add-visit-validate-text add-visit-validate-text-ship"
                    : "add-visit-validate-text add-visit-validate-text-hidden add-visit-validate-text-ship"
                }
              >
                Please select ship
              </div>
            </Col>
          </Row>
        </div>
        <div className="add-visit-date">
          <Row>
            <Col span={12} offset={6}>
              <Row>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                  <span>
                    <h1>Select date</h1>
                  </span>
                  {ShowDataPicker(shipId)}
                  <div
                    className={
                      !isValid && (startdate === null || enddate === null)
                        ? "add-visit-validate-text"
                        : "add-visit-validate-text add-visit-validate-text-hidden"
                    }
                  >
                    Please select date
                  </div>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                  <span>
                    <h1>Summary</h1>
                  </span>
                  <div className="add-visit-summary">
                    <Card>
                      Ship:{" "}
                      {shipId != null
                        ? ships.find((ship) => ship.Id === shipId)?.Name
                        : "-"}
                      <br />
                      Date:{" "}
                      {startdate != null && enddate != null
                        ? startdate?.toLocaleDateString() +
                          " - " +
                          enddate?.toLocaleDateString()
                        : "-"}
                      <br />
                      Port: {portName != null ? portName : "-"}
                    </Card>
                  </div>
                  <div className="add-visit-next-step">
                    <Button id="asd" onClick={setSelectionCompleted}>
                      Next step
                    </Button>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default ShipAndDateSelection;
